import { render, staticRenderFns } from "./Confirmacao.vue?vue&type=template&id=e9bd2b8a&scoped=true&"
import script from "./Confirmacao.vue?vue&type=script&lang=js&"
export * from "./Confirmacao.vue?vue&type=script&lang=js&"
import style0 from "./Confirmacao.vue?vue&type=style&index=0&id=e9bd2b8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9bd2b8a",
  null
  
)

export default component.exports